import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../api/axios";

function ViewInstall() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [instalacion, setInstalacion] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInstall = async () => {
      try {
        const res = await axios.get(`/api/viewInstall/${id}`);
        setInstalacion(res.data);
      } catch (error) {
        console.error("Error al obtener la instalación:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchInstall();
  }, [id]);

  if (loading) return <p>Cargando...</p>;
  if (!instalacion) return <p>No se encontró la instalación</p>;

  return (
    <div className="px-4 min-h-[calc(100vh-6rem)]">
      <button
        onClick={() => navigate(-1)}
        className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700 mb-4"
      >
        Volver
      </button>

      <div className="bg-secondary-100 p-6 rounded-lg shadow">
        <h1 className="text-xl font-bold mb-2">{instalacion.nombre}</h1>
        <p>
          <strong>Dirección:</strong> {instalacion.direccion}
        </p>
        <p>
          <strong>Teléfono:</strong> {instalacion.telefono}
        </p>
        <p>
          <strong>Población:</strong> {instalacion.poblacion}
        </p>

        <h2 className="text-lg font-bold mt-4">Elementos:</h2>
        {instalacion.productos.length === 0 ? (
          <p>No hay productos registrados.</p>
        ) : (
          <ul className="mt-2 space-y-2">
            {instalacion.productos.map((prod, idx) => (
              <li key={idx} className="bg-secondary-900 p-2 rounded text-white">
                {prod.referencia} - {prod.descripcion} (x{prod.cantidad})
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}

export default ViewInstall;
